import { apiClient } from './api';
import type {
  QuickBooksAuthResponse,
  QuickBooksCallbackResponse,
} from '../types';

class AuthService {
  async getQuickBooksAuthUrl(): Promise<QuickBooksAuthResponse> {
    return apiClient.get<QuickBooksAuthResponse>('/auth/quickbooks/authorize');
  }

  async handleQuickBooksCallback(
    code: string,
    state: string,
    realmId: string
  ): Promise<QuickBooksCallbackResponse> {
    return apiClient.get<QuickBooksCallbackResponse>(
      '/auth/quickbooks/callback',
      { code, state, realmId }
    );
  }

  saveQuickBooksTokens(response: QuickBooksCallbackResponse) {
    localStorage.setItem('quickbooks_access_token', response.access_token);
    localStorage.setItem('quickbooks_refresh_token', response.refresh_token);
    localStorage.setItem('quickbooks_realm_id', response.realm_id);
    localStorage.setItem(
      'quickbooks_token_expires_at',
      String(Date.now() + response.expires_in * 1000)
    );
  }

  clearQuickBooksTokens() {
    localStorage.removeItem('quickbooks_access_token');
    localStorage.removeItem('quickbooks_refresh_token');
    localStorage.removeItem('quickbooks_realm_id');
    localStorage.removeItem('quickbooks_token_expires_at');
  }

  isQuickBooksConnected(): boolean {
    const token = localStorage.getItem('quickbooks_access_token');
    const expiresAt = localStorage.getItem('quickbooks_token_expires_at');

    if (!token || !expiresAt) {
      return false;
    }

    return Date.now() < Number(expiresAt);
  }

  getRealmId(): string | null {
    return localStorage.getItem('quickbooks_realm_id');
  }
}

export const authService = new AuthService();
